import React from "react";
import styles from '../../resources/styles/preloader.module.scss'

export default function Index() {

    return (
        <div className={styles.preloader}>
            <div className={styles.spinner}>
                <div className={styles.doubleBounce1}/>
                <div className={styles.doubleBounce2}/>
            </div>
        </div>
    );
};
